














































































































































































































































































































































































































import AccordionCardWidget from "@/components/base/AccordionCardWidget.vue";
import FeedbackComponent from '@/components/base/FeedbackComponent'
import {CRMFileType} from "@/components/dashboard/customer-service/components/CreateNewCustomerServiceCRMContact.vue";
import SendNotification from "@/components/dashboard/customer-service/components/SendNotification.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {CrmFilterType} from "@/models/CrmFilterType";
import {EmployerCRMDetails, MemberCRMDetails} from "@/store/modules/customerService";
import {KeyValuePair, UserDetailsResponse} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";

export interface CRMContact {
  id: number;
  crmId?: number;
  statusCRM?: string;
  arrivalSubject?: string;
  contactSource?: string;
  currentReferralStatus?: string;
  lastRoutingUser?: string;
  dateCreated?: string;
  createDate?: string;
  dateReceive?: string;
  fullKitDate?: string;
  name?: string;
  uniqueIdentifier?: string;
  createdUser?: string;
  privateNotes?: string;
  userContactRouting?: string;
  sla: number;
  numberOfBusinessDays?: number;
  isMember: boolean;
  department?: string;
  accountNumber?: string;
  priority?: string;
  callDetails?: string;
  phoneNumber: string;
  employerNum?: number;
  servicePriorityIndex?: string;
}


@Component({
  components: {
    AccordionCardWidget,
    SendNotification
  }
})
export default class EditCRMContact extends FeedbackComponent {

  @Prop(Number) crmId!: number;
  @Prop() memberCRMDetails!: MemberCRMDetails
  @Prop() employerCRMDetails!: EmployerCRMDetails
  @Prop() crmFilterType!: CrmFilterType;


  @Action('getSourceOfArrival', StoreNamespace.CUSTOMER_SERVICE) getSourceOfArrival: any;
  @Action('getSubjectOfArrivalByCrmFilterType', StoreNamespace.CUSTOMER_SERVICE) getSubjectOfArrivalByCrmFilterType: any;
  @Action('getAllStatusesTypesByCrmFilterType', StoreNamespace.CUSTOMER_SERVICE) getAllStatusesTypesByCrmFilterType: any;
  @Action('getServicePriorities', StoreNamespace.CUSTOMER_SERVICE) getServicePriorities: any;
  @Action('updateCRMContact', StoreNamespace.CUSTOMER_SERVICE) updateCRMContact: any;
  @Action('uploadCRMAttachedFiles', StoreNamespace.CUSTOMER_SERVICE) uploadCRMAttachedFiles: any;
  @Getter('userDetails', StoreNamespace.AUTHENTICATION) userDetails!: UserDetailsResponse
  @Action('getCRMDepartments', StoreNamespace.CUSTOMER_SERVICE) getCRMDepartments: any;
  @Action('getUsersBySubjectOfArrivalId', StoreNamespace.CUSTOMER_SERVICE) getUsersBySubjectOfArrivalId: any;
  @Action('getCRMContact', StoreNamespace.CUSTOMER_SERVICE) getCRMContact: any;
  @Action('getConfigCRMDetails', StoreNamespace.CUSTOMER_SERVICE) getConfigCRMDetails: any;


  private contactData: CRMContact | null = null
  private usersList: KeyValuePair[] = []
  private departmentList: any[] | undefined = []
  private selectedDepartment: KeyValuePair = {} as KeyValuePair
  private selectedCRMFileType: CRMFileType = CRMFileType.FILE_ONE;
  private sourceOfArrivalList: any[] | undefined = []
  private companyLevelCrm: any = {}
  private servicePrioritiesList: any[] | undefined = []
  private statusesTypesList: any[] | undefined = []
  private subjectOfArrivalList: any[] | undefined = []
  private setOfFinalStatusIds: any[] = []
  private selectedStatusType: KeyValuePair = {} as KeyValuePair
  private selectedServicePriority: KeyValuePair = {} as KeyValuePair
  private createdUser: string = ''
  private userForRouting: KeyValuePair | null = null
  private userForRoutingList: KeyValuePair[] = []
  private fullKitDate: Date = new Date();
  private dateReceive: Date = new Date();
  private mapFromDepartmentToArrivalSubjectList: any = null
  private selectedSubjectOfArrival: KeyValuePair = {} as KeyValuePair

  private attachmentFileOne: File[] = [];
  private attachmentFileTwo: File[] = [];
  private attachmentFileThree: File[] = [];
  private attachmentFileFour: File[] = [];
  private attachmentFileFive: File[] = [];
  private attachmentsMap = new Map<number, any>();

  private updatedCRMContactId: string = "";
  private remarks: string = ''
  private internalRemarks: string = ''
  private emailToReplay: string = ""
  private sendNotificationFlag: boolean = false
  private submitDisabled: boolean = false

  mounted() {
    this.usersList.push({description: this.userDetails.fullName, value: this.userDetails.idNumber})
    this.createdUser = this.usersList[0].value;

    this.getConfigCRMDetails({
      requestorCallback: this
    })

    this.getSourceOfArrival({
      requestorCallback: this,
      pathVariable: this.crmFilterType
    })

    this.getSubjectOfArrivalByCrmFilterType({
      requestorCallback: this,
      pathVariable: this.crmFilterType
    })

    this.getServicePriorities({
      requestorCallback: this
    })

    this.getAllStatusesTypesByCrmFilterType({
      requestorCallback: this,
      pathVariable: this.crmFilterType
    })

    if (this.crmId > 0) {
      this.getCRMContact({
        pathVariable: this.crmId,
        requestorCallback: this
      });
    }
  }

  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'uploadCRMAttachedFiles':
        this.showErrorPopupMessage(this.$t('customerService.popup.uploadAttachmentsErrorMessage').toString())
        this.getCRMContact({
          pathVariable: this.crmId,
          requestorCallback: this
        });
        break
      default:
        this.handleOnError(messages, code, requestName);
    }

  }

  private showErrorPopupMessage(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'warning',
      secondsToDisappear: 10
    })
  }

  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'getSourceOfArrival':
        this.sourceOfArrivalList = data
        break;

      case 'crmConfigurationManagement/getConfigCRMDetails':
        this.companyLevelCrm = data.companyLevelCrm
        break;

      case 'getSubjectOfArrivalByCrmFilterType':
        this.mapFromDepartmentToArrivalSubjectList = data.mapFromDepartmentToSubjectList
        this.getCRMDepartments({
          requestorCallback: this,
          pathVariable: this.crmFilterType
        })
        break;

      case 'getCRMDepartments':
        this.departmentList = data
        if (this.departmentList) {
          this.selectedDepartment = this.departmentList[0]
        }
        break;

      case 'servicePriorities':
        this.servicePrioritiesList = data
        break;

      case 'statusesTypesByCrmFilterType':
        this.statusesTypesList = data.contactStatuses
        if (this.statusesTypesList) {
          this.selectedStatusType = this.statusesTypesList[0]
        }
        this.setOfFinalStatusIds = data.finalStatusIds

        break;

      case 'CRMContacts' :
        this.contactData = data;
        this.selectedSubjectOfArrival = data.contactSubject

        this.getUsersBySubjectOfArrivalId({
          requestorCallback: this,
          pathVariable: data.contactSubject.value
        });
        break;

      case 'updateCRMContact':
        this.sendNotificationToCustomerAndUploadAttachments(data.contactId)
        break;

      case 'uploadCRMAttachedFiles':
        this.afterSuccessUpdate()
        break;

      case 'getUsersBySubjectOfArrivalId':
        this.userForRoutingList = data.users
        this.emailToReplay = data.email
        break;
    }
  }

  async sendNotificationToCustomerAndUploadAttachments(contactId: any) {
    this.updatedCRMContactId = contactId
    this.sendNotificationFlag = true;
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.uploadAttachments()
  }

  private afterSuccessUpdate() {
    this.sendNotificationFlag = false
    this.remarks = ""
    this.internalRemarks = ""
    this.submitDisabled = false;

    this.$emit('onSubmitEdit');
    this.$emit('afterSuccessfullyCreated');
    this.getCRMContact({
      pathVariable: this.crmId,
      requestorCallback: this
    });
  }

  private onRemovedAttachmentClicked(fileType: CRMFileType) {
    switch (fileType) {
      case CRMFileType.FILE_ONE:
        this.attachmentFileOne = [];
        break;
      case CRMFileType.FILE_TWO:
        this.attachmentFileTwo = [];
        break;
      case CRMFileType.FILE_THREE:
        this.attachmentFileThree = [];
        break;
      case CRMFileType.FILE_FOUR:
        this.attachmentFileFour = [];
        break;
      case CRMFileType.FILE_FIVE:
        this.attachmentFileFive = [];
        break;
    }
    this.attachmentsMap.delete(fileType)

  }

  onInputFile(files: any[], fileType: CRMFileType) {
    if (files.length === 0) {
      return
    }

    switch (fileType) {
      case CRMFileType.FILE_ONE:
        this.attachmentFileOne = files;
        break;
      case CRMFileType.FILE_TWO:
        this.attachmentFileTwo = files;
        break;
      case CRMFileType.FILE_THREE:
        this.attachmentFileThree = files;
        break;
    }

    this.attachmentsMap.set(fileType, files[0]);
  }

  private saveUpdatedContact() {

    const updatedContactRequest = {
      crmId: this.crmId,
      remarks: this.remarks,
      internalRemarks: this.internalRemarks,
      updatedUser: this.userForRouting?.value,
      userForRouting: this.userForRouting?.value,
      userForRoutingName: this.userForRouting?.description,
      statusType: Number.parseInt(this.selectedStatusType.value),
      servicePriorities: Number.parseInt(this.selectedServicePriority.value),
      subjectOfArrival: Number.parseInt(this.selectedSubjectOfArrival.value),
      addAttachment: this.attachmentsMap.size > 0,
      fullKitDate: this.fullKitDate,
      dateReceive: this.dateReceive
    }

    this.submitDisabled = true;

    this.updateCRMContact({
      requestBody: {
        ...updatedContactRequest,
      },
      requestorCallback: this
    })
  }

  private uploadAttachments() {
    this.contactData = null

    if (this.attachmentsMap.size == 0) {
      this.afterSuccessUpdate()
      return;
    }


    const formData: FormData = new FormData();
    formData.append('contactId', this.updatedCRMContactId)

    this.attachmentsMap.forEach((value, key) => {
      formData.append('files', value.file);
    });

    this.uploadCRMAttachedFiles({
      requestorCallback: this,
      requestBody: formData
    });
  }

  onSelectedDepartment(selectValue: any) {

    const index: number = Number.parseInt(selectValue.value)
    this.subjectOfArrivalList = []
    if (this.mapFromDepartmentToArrivalSubjectList) {
      setTimeout(() => {
        this.subjectOfArrivalList = this.mapFromDepartmentToArrivalSubjectList[index]
        if (this.subjectOfArrivalList && this.subjectOfArrivalList.length > 0) {
          this.selectedSubjectOfArrival = this.subjectOfArrivalList[0];
        }
      }, 100);
    }
  }

  onSelectedSubjectOfArrival(selectValue: any) {
    this.userForRoutingList = []
    this.getUsersBySubjectOfArrivalId({
      requestorCallback: this,
      pathVariable: selectValue.value
    })
  }

  private getPriorityColor(value: string) {
    switch (value) {
      case "1":
        return "blue"
      case "2":
        return "orange"
      case "3":
        return "green"
      case "4":
        return "red"
    }

    return 'black'
  }

  get isFinalStatusSelected(): boolean {
    let idValue = Number.parseInt(this.selectedStatusType.value);

    return this.setOfFinalStatusIds.includes(idValue)
  }

  get getContactCreatedDate(): Date {
    if (this.contactData) {

      if (this.contactData.dateReceive) {

        return new Date(this.contactData.dateReceive);
      } else if (this.contactData.createDate) {
        const [datePart, timePart] = this.contactData.createDate.split(" ");
        const [day, month, year] = datePart.split("/").map(Number);
        const [hours, minutes] = timePart.split(":").map(Number);

        return new Date(year, month - 1, day, hours, minutes);
      }
    }

    return new Date()
  }


  get getFullKitDate(): Date {
    if (this.contactData && this.contactData.fullKitDate) {
      return new Date(this.contactData.fullKitDate)
    }

    return new Date()
  }
}


